import type { AxiosInstance } from 'axios';
import authService from './auth.service';
import { geolocationHeader } from '../lib/geolocation';

export interface AwaitingPayout {
  payout_id: string;
  net_amount: string;
  /** The management fee already deducted from `net_amount` at a full exit, when there is one. */
  management_fee_amount?: string | null;
  currency_code: string;
  version: number;
  created_at: string;
  current_destination_id: string | null;
}

/** The payee's side of a payout (`/api/v1/clients/{id}/payouts`): choosing where it
 *  is sent. There is no staff equivalent of `chooseDestination`, by design. */
class ClientPayoutsService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async awaiting(): Promise<AwaitingPayout[]> {
    const id = await authService.getMyId();
    const res = await this.api.get<AwaitingPayout[]>(`/api/v1/clients/${id}/payouts/awaiting`);
    return res.data;
  }

  async chooseDestination(
    payout: AwaitingPayout, clientBankAccountId: string, mfaCode: string,
  ): Promise<void> {
    const id = await authService.getMyId();
    // A client money-out act: gated on precise browser location, like adding an account.
    const headers = await geolocationHeader();
    await this.api.post(
      `/api/v1/clients/${id}/payouts/${payout.payout_id}/destination`,
      {
        client_bank_account_id: clientBankAccountId,
        expected_version: payout.version,
        mfa_code: mfaCode,
      },
      { headers },
    );
  }
}

export default new ClientPayoutsService();
